import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { StorageEnum } from 'src/app/shared/enums/storage.enum';
import { FacilityModel } from 'src/app/shared/models/login-response.model';
import { StorageService } from './storage.service';
import { ALPHABETS, IS_PCC_ENABLED, MAX_BEDS_LIST, NUMBERS } from 'src/app/shared/config/app.constant';

@Injectable({
  providedIn: 'root',
})
export class HeaderService {
  pageChange = new Subject<any>();
  reportsPageChange = new Subject<any>();
  private selectedFacility: Subject<FacilityModel> =
    new Subject<FacilityModel>();
  onGetMessagesData: Subject<any> = new Subject();
  updateMessagesList: Subject<any> = new Subject();

  constructor(private storageService: StorageService) { }

  changeFacility(selectedFacility: FacilityModel) {
    this.selectedFacility.next(selectedFacility);
  }

  getFacility() {
    return this.selectedFacility.asObservable();
  }

  /**
   * Get current facility
   */
  get getCurrentFacility(): FacilityModel {
    return (
      this.storageService.getLocalStorage(
        StorageEnum.selectedFacility,
        true
      ) || new FacilityModel()
    );
  }

  /**
   * Get facility ID
   */
  getFacilityId(): string {
    return this.getCurrentFacility.facilityId;
  }

  /**
   * Get facility Name
   */
  getFacilityName(): string {
    return this.getCurrentFacility.facilityName;
  }

  /**
   * Get facility ID
   */
  getCasparSiteId(): string {
    return this.getCurrentFacility.caspar_siteid;
  }

  getFacilityList(): any[] {
    const loginData = this.storageService.getLocalStorage(
      StorageEnum.loginData,
      true
    );
    return loginData.facility || [];
  }

  get isPCCEnabled() {
    // return IS_PCC_ENABLED;
    return this.getCurrentFacility.enablePCC;
  }

  get isEtectRxEnabled() {
    return true;
    // return this.getCurrentFacility.etectrxEnabled;
  }

  get isCasparEnabled() {
    return this.getCurrentFacility.enableCaspar;
  }

  get isBedSlotEnabled() {
    return true; // this.isPCCEnabled;
  }

  get bedSlotOptions() {
    const pccOffBedSlot = this.getCurrentFacility.pccOffBedSlot;
    const pccOffMaxmBedSlotPerRoom = this.getCurrentFacility.pccOffMaxmBedSlotPerRoom;
    const bedSlotList: any[] = [];
    const maxSlots = MAX_BEDS_LIST[MAX_BEDS_LIST.length - 1]?.key;
    if (pccOffBedSlot === ALPHABETS) {
      const alphabetArray = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('').slice(0, maxSlots);
      for (const char of alphabetArray) {
        bedSlotList.push({
          bedslotId: char,
          slotName: char,
          BedName: null,
          bedId: null,
          wearerId: null,
          wearerName: null,
        });
      }
    } else if (pccOffBedSlot === NUMBERS) {
      for (let i = 1; i <= maxSlots; i++) {
        bedSlotList.push({
          bedslotId: i.toString(),
          slotName: i.toString(),
          BedName: null,
          bedId: null,
          wearerId: null,
          wearerName: null,
        });
      }
    }
    return bedSlotList.slice(0, pccOffMaxmBedSlotPerRoom);;
  }
}
